// extracted by mini-css-extract-plugin
export var displayNone = "_og-6";
export var imgContainer = "_og-2";
export var overflowHidden = "_og-3";
export var productInfoCardButtonContainer = "_og-5";
export var productTitleText = "_og-4";
export var rightArrow = "_og-1";
export var rightArrowContainer = "_og-0";